import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { CapituloModel } from '../models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CapituloService {
  context = '/capitulos';
  constructor(private apiService: ApiService) {}

  add(conteudo: CapituloModel): Observable<CapituloModel> {
    return this.apiService.post(this.context, { conteudo }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getAll(params: HttpParams): Observable<CapituloModel[]> {
    return this.apiService.get(this.context, params);
  }

  // getById(id: string): Observable<CapituloModel> {
  //   return this.apiService.get(`${this.context}/${id}`);
  // }

  getByCurso(cursoId: number): Observable<CapituloModel[]> {
    return this.apiService.get(`${this.context}/${cursoId}`);
  }

  update(conteudo: CapituloModel): Observable<CapituloModel> {
    const { id } = conteudo;
    return this.apiService.put(`${this.context}/${id}`, conteudo).pipe(
      map((data) => {
        return data;
      })
    );
  }

  delete(id: string) {
    return this.apiService.delete(`${this.context}/${id}`).pipe(
      map((data) => {
        return data;
      })
    );
  }
}
